// Accent + solid color presets. The image wallpaper library lives in ./wallpaperArt.js.
// GNOME-style Background panel separates "Wallpapers" (images) from "Colors" (solid fills).

// Solid background colors (flat — default brand tone first).
export const COLORS = [
  { id: "midnight", name: "Midnight", css: "#121622" },
  { id: "graphite", name: "Graphite", css: "#16181d" },
  { id: "slate", name: "Slate", css: "#1b2330" },
  { id: "navy", name: "Navy", css: "#13243a" },
  { id: "plum", name: "Plum", css: "#241a2e" },
  { id: "forest", name: "Forest", css: "#13231c" },
];

export const ACCENTS = [
  { id: "blue", name: "Adwaita Blue", accent: "#3584e4", hover: "#4a93e8" },
  { id: "teal", name: "Teal", accent: "#2190a4", hover: "#27a8bf" },
  { id: "green", name: "Green", accent: "#26a269", hover: "#2cb677" },
  { id: "purple", name: "Purple", accent: "#9141ac", hover: "#a050bd" },
  { id: "orange", name: "Orange", accent: "#e66100", hover: "#f06d10" },
  { id: "pink", name: "Pink", accent: "#d56199", hover: "#e070a6" },
];
